/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const RenewalIcon: React.SFC = () => {
    return (
        <svg width="33" height="20" xmlns="http://www.w3.org/2000/svg">
            <g fill="#CFD8DD" fillRule="evenodd">
                <path d="M22.525 15.786A7.965 7.965 0 0 1 17 18a8 8 0 1 1 0-16c2.279 0 4.4.955 5.907 2.605.378.413.89.632 1.408.65l.068-2A9.974 9.974 0 0 0 17 0C11.477 0 7 4.477 7 10s4.477 10 10 10a9.966 9.966 0 0 0 6.906-2.768c.311-.406.47-.71.477-.911.009-.243-.128-.605-.408-1.088a1.994 1.994 0 0 0-1.45.553z" fillRule="nonzero" />
                <path d="M26.104.105l-.105 5.999L20 5.999z" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Renewal/Renewal.tsx